import React from 'react';
import PropTypes from 'prop-types';

import StackedProductsOverView from './mobile/StackedProductsOverview';
import CarrouselProductsOverView from './mobile/CarrouselProductsOverview';
import CollapsibleProductsOverview from './desktop/CollapsibleProductsOverview';
import { mediaQueryHOC } from '../../adapters/helpers/Hooks'

function ProductsOverview({
    products,
    seeMoreProductsText,
    seeLessProductsText,
    itemsPerLine,
    whiteText,
    isCarrousel,
    isMedium,
    onClickCallback,
    productOverview,
    removeLazyLoad,
    isRecentlyViewed,
    isNewCarrousel,
    rightArrowIcon,
    leftArrowIcon,
    carouselSettings,
    isArticle,
    rightArrowIconArticle,
    leftArrowIconArticle,
}) {
    const carrouselProps = {
        products,
        isNewCarrousel,
        rightArrowIcon,
        leftArrowIcon,
        carouselSettings,
        whiteText,
        onClickCallback,
        productOverview,
        isMedium,
        removeLazyLoad,
        isArticle,
        rightArrowIconArticle,
        leftArrowIconArticle,
    };

    const stackedProps = {
        products,
        whiteText,
        onClickCallback,
        productOverview,
        isMedium,
        removeLazyLoad,
    };

    const collapsibleProps = {
        products,
        seeMoreProductsText,
        seeLessProductsText,
        whiteText,
        isRecentlyViewed,
        itemsPerRow: itemsPerLine,
        onClickCallback,
        productOverview,
        removeLazyLoad,
    };
    return (
        <div>
            {isMedium ? (
                isCarrousel || isNewCarrousel ? (
                    <CarrouselProductsOverView {...carrouselProps} />
                ) : (
                    <StackedProductsOverView {...stackedProps} />
                )
            ) : (
                <CollapsibleProductsOverview {...collapsibleProps} />
            )}
        </div>
    );
}

export default mediaQueryHOC(ProductsOverview);

ProductsOverview.defaultProps = {
    itemsPerLine: 3,
    products: [],
    isCarrousel: false,
    isRecentlyViewed: false,
    removeLazyLoad: false,
}

ProductsOverview.propTypes = {
    itemsPerLine: PropTypes.number,
    children: PropTypes.any,
    seeMoreProductsText: PropTypes.string,
    seeLessProductsText: PropTypes.string,
    products: PropTypes.any,
    whiteText: PropTypes.any,
    isMedium: PropTypes.bool,
    isCarrousel: PropTypes.bool,
    isRecentlyViewed: PropTypes.bool,
    removeLazyLoad: PropTypes.bool,
    onClickCallback: PropTypes.func.isRequired,
    productOverview: PropTypes.any
}
